import http from './http'

export default class PageAPI {
	//新版百度统计
	// 百度统计代码
	static bindingCode(data) {
		return http.httpPost('/baiduBinding/bingScript', data)
	}
	/**获取绑定得百度账号信息 */
	static getBaiduAccount(params) {
		return http.httpGet('/baiduBinding/getAccount', params)
	}
	//绑定账号
	static preLogin(data) {
		return http.httpPost('/lavrock/baiduBinding/preLogin', data)
	}
	// 验证图片验证码
	static verifyImgCode(data) {
		return http.httpPost('/baiduBinding/doLogin', data)
	}
	//获取域名对应的siteId
	static getSiteRelation(data) {
		return http.httpGet('/lavrock/baiduBinding/getSiteRelation', data)
	}
	// 按天统计（按小时统计）
	static getRealtime(data) {
		return http.httpGet('/lavrock/baiduBinding/getRealtime', data)
	}
	// 按一段时间统计（按天统计）
	static getDaily(data) {
		return http.httpGet('/lavrock/baiduBinding/getDaily', data)
	}
	/**
	 *  关键字查询
	 * @param { account, siteId, startDay, endDay} params
	 */
	static getSearchWord(params) {
		return http.httpGet('/lavrock/baiduBinding/searchword', params)
	}

	static getDailyAmount(params) {
		return http.httpGet('/lavrock/baiduBinding/getDailyAmount', params)
	}
	static getFtpInfo(params) {
		return http.httpGet('/lavrock/project/getFtpInfo', params)
	}
}
